<template>
  <div class="leftPage">
    <div class="title">
      <span class="huizong">今日运营汇总</span>
      <span>{{ nowDate }}</span>
      <span>{{ nowDay }}</span>
    </div>
    <div class="topBox">
      <div class="everyBox" v-for="item, index in topBoxData" :key="index">
        <div class="biaoti">
          {{ item.label }}
          <span v-if="index == 0" style="color:#8c8c8c">(元)</span>
        </div>
        <div class="number">
          {{ item.value }}
          <span v-if="index == 0" style="font-size:20px"></span>
        </div>
        <div class="yesterday">
          昨日
          <span>
            {{ item.yesterday }}
            <span v-if="index == 0" style="font-size:12px"></span>
          </span>
        </div>
        <div class="ratio" style="font-weight:500">
          环比
          <span :style="item.ratio >= 0 ? 'color:#F5222D' : 'color:#17A83C'">
            <img src="@/assets/shangzhang.png" style="width:8px" alt="" v-if="item.ratio >= 0">
            <img src="@/assets/xiadie.png" style="width:8px" alt="" v-else>
            {{ item.ratio >= 0 ? '+' : '' }} {{ item.ratio }} %
          </span>

        </div>
      </div>
    </div>
    <!-- <div class="itemBox">
      <div class="title">订单中心</div>
      <div class="mainBox">
        <div class="everyBox" v-for="item, index in firstBoxData" @click="tiaozhuan(item.path, item.tab, item.status)"
          :style="{ cursor: item.path ? 'pointer' : '' }" :key="index">
          <div class="everyTitle" :style="{ padding: index == 0 || index == 7 ? '0 0 0 0px' : '0 0 0 40px' }">{{
            item.label }}
          </div>
          <div class="everyNumber"
            :style="{ color: `${item.color}`, border: index == 6 ? 'none' : '', padding: index == 0 || index == 7 ? ' 0 0 0 0px' : '0 0 0 40px' }">
            {{ item.value }}</div>
        </div>
      </div>
    </div> -->
    <div class="itemBox">
      <div class="title">订单中心</div>
      <div class="subTitle">订单</div>
      <div class="mainBox">
        <div class="everyBox" v-for="item, index in orderNewData" @click="tiaozhuan(item.path, item.tab, item.status)"
          :style="{ cursor: item.path ? 'pointer' : '' }" :key="index">
          <div class="everyTitle" :style="{ padding: index == 0 || index == 7 ? '0 0 0 0px' : '0 0 0 40px' }">{{
            item.label }}
          </div>
          <div class="everyNumber"
            :style="{ color: `${item.color}`, border: index == 6 || index == orderNewData.length - 1 ? 'none' : '', padding: index == 0 || index == 7 ? ' 0 0 0 0px' : '0 0 0 40px' }">
            {{ item.value }}</div>
        </div>
      </div>
      <div class="subTitle">售后订单</div>
      <div class="mainBox">
        <div class="everyBox" v-for="item, index in afterSaleNewData" @click="tiaozhuan(item.path, item.tab, item.status)"
          :style="{ cursor: item.path ? 'pointer' : '' }" :key="index">
          <div class="everyTitle" :style="{ padding: index == 0 ? '0 0 0 0px' : '0 0 0 40px' }">{{
            item.label }}
          </div>
          <div class="everyNumber"
            :style="{ color: `${item.color}`, border: index == afterSaleNewData.length - 1 ? 'none' : '', padding: index == 0 ? ' 0 0 0 0px' : '0 0 0 40px' }">
            {{ item.value }}</div>
        </div>
      </div>
    </div>
    <div class="itemBox">
      <div class="title">客户中心</div>
      <div class="mainBox">
        <div class="everyBox" @click="tiaozhuan(item.path, item.tab, item.status)"
          :style="{ cursor: item.path ? 'pointer' : '' }" v-for="item, index in secondBoxData" :key="index">
          <div class="everyTitle" :style="{ padding: index == 0 || index == 7 ? '0 0 0 0px' : '0 0 0 40px' }">{{
            item.label }}
          </div>
          <div class="everyNumber"
            :style="{ color: `${item.color}`, border: index == 5 ? 'none' : '', padding: index == 0 || index == 7 ? ' 0 0 0 0px' : '0 0 0 40px' }">
            {{ item.value }}</div>
        </div>
      </div>
    </div>
    <div class="itemBox">
      <div class="title">商品中心</div>
      <div class="mainBox">
        <div class="everyBox" @click="tiaozhuan(item.path, item.tab, item.status)" :style="{ cursor: item.path ? 'pointer' : '' }" v-for="item, index in fileterThirdBoxData" :key="index">
          <div class="everyTitle" :style="{ padding: index == 0 || index == 7 ? '0 0 0 0px' : '0 0 0 40px' }">{{item.label }}</div>
          <div class="everyNumber":style="{ color: `${item.color}`, border: index == 6 || index == 8 ? 'none' : '', padding: index == 0 || index == 7 ? ' 0 0 0 0px' : '0 0 0 40px' }">{{ item.value }}</div>
        </div>
      </div>
    </div>
    <div class="itemBox">
      <div class="title">商户中心</div>
      <div class="mainBox">
        <div class="everyBox" @click="tiaozhuan(item.path, item.tab, item.status)"
          :style="{ cursor: item.path ? 'pointer' : '' }" v-for="item, index in forthBoxData" :key="index">
          <div class="everyTitle" :style="{ padding: index == 0 || index == 7 ? '0 0 0 0px' : '0 0 0 40px' }">{{
            item.label }}
          </div>
          <div class="everyNumber"
            :style="{ color: `${item.color}`, border: index == 5 ? 'none' : '', padding: index == 0 || index == 7 ? ' 0 0 0 0px' : '0 0 0 40px' }">
            {{ item.value }}</div>
        </div>
      </div>
    </div>
    <div class="itemBox">
      <div class="title">业务中心</div>
      <div class="mainBox">
        <div class="everyBox" v-for="item, index in fiveBoxData" :key="index">
          <div class="everyTitle" :style="{ padding: index == 0 || index == 7 ? '0 0 0 0px' : '0 0 0 40px' }">{{
            item.label }}
          </div>
          <div class="everyNumber"
            :style="{ color: `${item.color}`, border: index == 5 ? 'none' : '', padding: index == 0 || index == 7 ? ' 0 0 0 0px' : '0 0 0 40px' }">
            {{ item.value }}</div>
        </div>
      </div>
    </div>

  </div>
</template>
  
<script>
import { adaption, saleTodayCount, afterSaleTodayCount } from '@/api/home/index'
import dayjs from 'dayjs'

export default {
  props: {},
  data () {
    return {
      shopId: '',
      nowDate: dayjs().format('YYYY/MM/DD'),
      nowDay: '',
      // 今日运营汇总
      topBoxData: [
        {
          label: '支付金额',
          value: '0.00',
          yesterday: '0',
          ratio: '0.0000',
        },
        {
          label: '成交订单',
          value: '0',
          yesterday: '0',
          ratio: '0.0000',
        },
        {
          label: '支付买家',
          value: '0',
          yesterday: '0',
          ratio: '0.0000',
        },
        {
          label: '访客数',
          value: '0',
          yesterday: '0',
          ratio: '0.0000',
        },
        {
          label: '商品浏览数',
          value: '0',
          yesterday: '0',
          ratio: '0.0000',
        }
      ],
      // 订单中心
      firstBoxData: [
        {
          label: '待支付',
          value: '0',
          color: '#262626',
          path: '/business/businessManage-order-index'
        },
        {
          label: '待确认',
          value: '0',
          color: '#BFBFBF',
          path: '/business/businessManage-order-index'
        },
        {
          label: '待开户',
          value: '0',
          color: '#262626',
          path: '/business/businessManage-order-index'
        },
        {
          label: '待发货',
          value: '0',
          color: '#262626',
          path: '/business/businessManage-order-index'
        },
        {
          label: '将超时',
          value: '0',
          color: '#F55A22'
        },
        {
          label: '已超时',
          value: '0',
          color: '#F5222D'
        },
        {
          label: '售后处理',
          value: '0',
          color: '#262626',
          path: '/audit/auditcenter-salesTreatment'
        }
      ],
      // 订单中心-新 订单状态（与订单列表筛选条件保持一致）
      orderNewData: [
        { label: '待发货', value: '0', color: '#262626', path: '/business/businessManage-order-index', status: '2', countKey: 'waitDeliverCount' },
        { label: '配送中', value: '0', color: '#262626', path: '/business/businessManage-order-index', status: '3', countKey: 'deliveringCount' },
        { label: '交易取消', value: '0', color: '#BFBFBF', path: '/business/businessManage-order-index', status: '5', countKey: 'cancelCount' },
        { label: '签收', value: '0', color: '#262626', path: '/business/businessManage-order-index', status: '8', countKey: 'signedCount' },
        { label: '完成', value: '0', color: '#262626', path: '/business/businessManage-order-index', status: '9', countKey: 'finishedCount' },
        { label: '待开户', value: '0', color: '#F55A22', path: '/business/businessManage-order-index', status: '11', countKey: 'waitOpenAccountCount' },
        { label: '待确款', value: '0', color: '#F55A22', path: '/business/businessManage-order-index', status: '12', countKey: 'waitConfirmPaymentCount' },
      ],
      // 订单中心-新 售后状态
      afterSaleNewData: [
        { label: '待处理', value: '0', color: '#F55A22', path: '/audit/auditcenter-salesTreatment', status: 'PENDING', countKey: 'pendingCount' },
        { label: '商户待举证', value: '0', color: '#F55A22', path: '/audit/auditcenter-salesTreatment', status: 'WAIT_EVIDENCE', countKey: 'waitEvidenceCount' },
        { label: '同意售后', value: '0', color: '#262626', path: '/audit/auditcenter-salesTreatment', status: 'AGREE', countKey: 'agreeCount' },
        { label: '驳回', value: '0', color: '#BFBFBF', path: '/audit/auditcenter-salesTreatment', status: 'REJECT', countKey: 'rejectCount' },
      ],
      // 客户中心
      secondBoxData: [
        {
          label: '今日新增',
          value: '0',
          color: '#262626',
          // path: '/business/businessManage-customer-index'
        },
        {
          label: '客户总数',
          value: '0',
          color: '#262626',
          path: '/business/businessManage-customer-index',
          status: '2',
        },
        {
          label: '待一审',
          value: '0',
          color: '#F55A22',
          path: '/business/businessManage-customer-index',
          status: '0',
        },
        {
          label: '待二审',
          value: '0',
          color: '#F55A22',
          path: '/business/businessManage-customer-index',
          status: '20',
        },
        {
          label: '临期',
          value: '0',
          color: '#F55A22',
          path: '/business/businessManage-customer-index',
          tab: '3',
        },
        {
          label: '过期',
          value: '0',
          color: '#F5222D',
          path: '/business/businessManage-customer-index',
          tab: '2',
        },
      ],
      // 商品中心
      thirdBoxData: [
        {
          label: '在售商品',
          value: '0',
          color: '#262626',
          path: '/business/commodityOpsList-index',
          tab: 'ON_SALE'
        },
        {
          label: '未标价',
          value: '0',
          color: '#BFBFBF',
          path: '/business/commodityOpsList-index',
          tab: 'UNPRICED'
        },
        {
          label: '未上架',
          value: '0',
          color: '#262626',
          path: '/business/commodityOpsList-index',
        },
        {
          label: '上架待审核',
          value: '0',
          color: '#262626',
          path: '/business/commodityOpsList-index',
          tab: 'SKU_AWAIT'
        },
        {
          label: '商家下架',
          value: '0',
          color: '#F55A22',
          path: '/business/commodityOpsList-index',
          tab: 'MERCHANT_REMOVAL'
        },
        {
          label: '平台下架',
          value: '0',
          color: '#262626',
          path: '/business/commodityOpsList-index',
          tab: 'PLATFORM_REMOVAL'
        },
        {
          label: '库存不足7天',
          value: '0',
          color: '#F55A22'
        },
        {
          label: '30天未动销',
          value: '0',
          color: '#F55A22'
        },
        {
          label: '近效期',
          value: '0',
          color: '#F55A22'
        },
      ],
      // 商户中心
      forthBoxData: [
        {
          label: '今日新增',
          value: '0',
          color: '#262626',
          // path: '/business/businessManage-shop-index',
        },
        {
          label: '商户总数',
          value: '0',
          color: '#262626',
          path: '/business/businessManage-shop-index',
          status: '2',
        },
        {
          label: '待一审',
          value: '0',
          color: '#262626',
          path: '/business/businessManage-shop-index',
          status: '0',
        },
        {
          label: '待二审',
          value: '0',
          color: '#262626',
          path: '/business/businessManage-shop-index',
          status: '20',
        },
        {
          label: '临期',
          value: '0',
          color: '#F55A22',
          path: '/business/businessManage-shop-index',
          tab: '3',
        },
        {
          label: '过期',
          value: '0',
          color: '#F5222D',
          path: '/business/businessManage-shop-index',
          tab: '2',
        },
      ],
      // 业务中心
      fiveBoxData: [
        {
          label: '今日新增',
          value: '0',
          color: '#262626'
        },
        {
          label: '业务人员总数',
          value: '0',
          color: '#262626'
        },
        {
          label: '已关联区域',
          value: '0',
          color: '#262626'
        },
        {
          label: '已身份认证',
          value: '0',
          color: '#262626'
        },
        {
          label: '待审核',
          value: '0',
          color: '#F55A22'
        },
        {
          label: '应付余额 (元)',
          value: '0',
          color: '#262626'
        },
      ]
    }
  },
  components: {},
  async created () {
    await this.jiusanNowDate()
    await this.adaption(2)
    await this.adaption(3)
    await this.adaption(4)
    await this.adaption(5)
    await this.adaption(9)
    await this.adaption(10)
    await this.getSaleTodayCount()
    await this.getAfterSaleTodayCount()
  },
  mounted () {

  },
  watch: {},
  computed: {
    fileterThirdBoxData () {
      return this.thirdBoxData.filter(item => item.label != '未上架')
    }
  },
  methods: {
    // 路径跳转
    tiaozhuan (path, tab, status) {
      if (path) {
        let obj = {
          path: path,
          query: {
            tab: tab,
            status: status
          }
        }
        this.$router.push(obj)
      }
    },
    // 计算今天是星期几
    async jiusanNowDate () {
      let a = new Date().getDay()
      switch (a) {
        case 0:
          this.nowDay = '星期日'
          break;
        case 1:
          this.nowDay = '星期一'
          break;
        case 2:
          this.nowDay = '星期二'
          break;
        case 3:
          this.nowDay = '星期三'
          break;
        case 4:
          this.nowDay = '星期四'
          break;
        case 5:
          this.nowDay = '星期五'
          break;
        case 6:
          this.nowDay = '星期六'
          break;
        default:
          break;
      }
    },
    // 首页实时数据
    async adaption (type) {
      let params = {
        type: type
      }
      adaption(params).then(res => {
        if (res) {
          // console.log(res)
          switch (type) {
            case 2:
              this.topBoxData[0].value = res[0].sale_amt ? res[0].sale_amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'
              this.topBoxData[1].value = res[0].sale_num ? res[0].sale_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.topBoxData[2].value = res[0].pay_shop_num ? res[0].pay_shop_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.topBoxData[3].value = res[0].uv ? res[0].uv.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.topBoxData[4].value = res[0].goods_pv ? res[0].goods_pv.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'

              this.topBoxData[0].yesterday = res[0].sale_amt_yday ? res[0].sale_amt_yday.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'
              this.topBoxData[1].yesterday = res[0].sale_num_yday ? res[0].sale_num_yday.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.topBoxData[2].yesterday = res[0].pay_shop_num_yday ? res[0].pay_shop_num_yday.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.topBoxData[3].yesterday = res[0].uv_yday ? res[0].uv_yday.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.topBoxData[4].yesterday = res[0].goods_pv_yday ? res[0].goods_pv_yday.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'

              this.topBoxData[0].ratio = res[0].sale_amt_ror ? (res[0].sale_amt_ror * 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'
              this.topBoxData[1].ratio = res[0].sale_num_ror ? (res[0].sale_num_ror * 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'
              this.topBoxData[2].ratio = res[0].pay_shop_num_ror ? (res[0].pay_shop_num_ror * 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'
              this.topBoxData[3].ratio = res[0].uv_ror ? (res[0].uv_ror * 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'
              this.topBoxData[4].ratio = res[0].goods_pv_ror ? (res[0].goods_pv_ror * 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'
              break;
            case 3:
              this.secondBoxData[0].value = res[0].new_custom_num ? res[0].new_custom_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.secondBoxData[1].value = res[0].total_custom_num ? res[0].total_custom_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.secondBoxData[2].value = res[0].wait_one_approve ? res[0].wait_one_approve.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.secondBoxData[3].value = res[0].wait_two_approve ? res[0].wait_two_approve.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.secondBoxData[4].value = res[0].near_expire_num ? res[0].near_expire_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.secondBoxData[5].value = res[0].expire_num ? res[0].expire_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              break;
            case 4:
              this.thirdBoxData[0].value = res[0].onsale_goods_num ? res[0].onsale_goods_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.thirdBoxData[1].value = res[0].non_sale_price ? res[0].non_sale_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.thirdBoxData[2].value = res[0].non_onsale ? res[0].non_onsale.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.thirdBoxData[3].value = res[0].onsale_need_approve ? res[0].onsale_need_approve.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.thirdBoxData[4].value = res[0].phmc_offsale ? res[0].phmc_offsale.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.thirdBoxData[5].value = res[0].platform_offsale ? res[0].platform_offsale.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.thirdBoxData[6].value = res[0].low_7_days_stock ? res[0].low_7_days_stock.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.thirdBoxData[7].value = res[0].non_sale_30_days ? res[0].non_sale_30_days.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.thirdBoxData[8].value = res[0].near_expire_time ? res[0].near_expire_time.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              break;
            case 5:
              this.fiveBoxData[0].value = res[0].new_sale_user ? res[0].new_sale_user.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.fiveBoxData[1].value = res[0].total_sale_user ? res[0].total_sale_user.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.fiveBoxData[2].value = res[0].area_sale_user ? res[0].area_sale_user.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.fiveBoxData[3].value = res[0].confirm_sale_user ? res[0].confirm_sale_user.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.fiveBoxData[4].value = res[0].need_audit ? res[0].need_audit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.fiveBoxData[5].value = res[0].balance ? res[0].balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.000000'
              break;
            case 9:
              this.forthBoxData[0].value = res[0].new_custom_num ? res[0].new_custom_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.forthBoxData[1].value = res[0].total_custom_num ? res[0].total_custom_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.forthBoxData[2].value = res[0].wait_one_approve ? res[0].wait_one_approve.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.forthBoxData[3].value = res[0].wait_two_approve ? res[0].wait_two_approve.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.forthBoxData[4].value = res[0].near_expire_num ? res[0].near_expire_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.forthBoxData[5].value = res[0].expire_num ? res[0].expire_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              break;
            case 10:
              this.firstBoxData[0].value = res[0].need_pay_num ? res[0].need_pay_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.firstBoxData[1].value = res[0].need_confirm_pay ? res[0].need_confirm_pay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.firstBoxData[2].value = res[0].need_open_account ? res[0].need_open_account.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.firstBoxData[3].value = res[0].need_deliver_num ? res[0].need_deliver_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.firstBoxData[4].value = res[0].will_time_out_num ? res[0].will_time_out_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.firstBoxData[5].value = res[0].time_out_num ? res[0].time_out_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              this.firstBoxData[6].value = res[0].after_sale_num ? res[0].after_sale_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
              break;
            default:
              break;
          }
        }
      })
    },
    // 首页-订单中心(新) 今日订单数量
    getSaleTodayCount () {
      return saleTodayCount().then((res) => {
        const data = this.unwrapData(res)
        this.orderNewData.forEach((item) => {
          item.value = this.formatCount(data[item.countKey])
        })
      }).catch(() => { })
    },
    // 首页-订单中心(新) 今日售后数量
    getAfterSaleTodayCount () {
      return afterSaleTodayCount().then((res) => {
        const data = this.unwrapData(res)
        this.afterSaleNewData.forEach((item) => {
          item.value = this.formatCount(data[item.countKey])
        })
      }).catch(() => { })
    },
    // 拆包：接口返回 { code, data } 时取 data，否则直接用返回体
    unwrapData (res) {
      return res && res.code !== undefined && res.data !== undefined ? res.data : (res || {})
    },
    // 千分位格式化，缺省为 0（与 adaption 保持一致）
    formatCount (val) {
      return val === undefined || val === null || val === ''
        ? '0'
        : Number(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  }
}

</script>
<style lang="scss" scoped>
@font-face {
  font-family: "myFont";
  src: url("../../fonts/BebasNeue-1.otf");
}

.leftPage {
  .title {
    display: flex;
    align-items: center;

    span {
      margin-left: 9px;
      font-size: 12px;
      font-family: Helvetica, Helvetica-Regular;
      font-weight: 400;
      text-align: left;
      color: #8c8c8c;
      line-height: 20px;
    }

    .huizong {
      margin-left: 0px;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
      line-height: 24px;
    }
  }

  .topBox {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;

    .everyBox {
      width: calc(20% - 6.4px);
      padding: 16px;
      // height: 132px;
      border: 1px solid #ededed;
      border-radius: 4px;

      .biaoti {
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: left;
        color: #262626;
        line-height: 17px;
      }

      .number {
        font-size: 30px;
        font-family: "myFont";
        font-weight: 500;
        text-align: left;
        color: #262626;
        line-height: 37px;
        letter-spacing: 0.2px;
      }

      .yesterday {
        height: 20px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #8c8c8c;
        line-height: 20px;
      }

      .ratio {
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #8c8c8c;
        line-height: 20px;
      }
    }
  }

  .itemBox {
    margin-top: 16px;
    padding: 16px;
    border: 1px solid #ededed;
    border-radius: 4px;

    .title {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
      line-height: 24px;
    }

    .mainBox {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      // margin-top: 20px;
    }

    .subTitle {
      margin-top: 12px;
      font-size: 13px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: left;
      color: #595959;
      line-height: 20px;
    }

    .everyBox {
      width: 14.28%;
      margin-top: 14px;

      .everyTitle {
        padding-left: 40px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #595959;
        line-height: 17px;
      }

      .everyNumber {
        padding-left: 40px;
        border-right: 1px solid #ededed;
        font-size: 30px;
        font-family: "myFont";
        font-weight: 500;
        text-align: left;
        color: #262626;
        line-height: 37px;
        letter-spacing: 0.2px;
      }
    }
  }
}
</style>

